import "./bootstrap";
import Vue from "vue";

import Core from "./core";
import router from "./router";
import store from "./store";
// import { i18n } from "@/core/services/i18n";

import App from "./App";

Vue.config.productionTip = false;
const core = new Core();

new Vue({
  core,
  router,
  store,
  // i18n,
  render: h => h(App)
}).$mount("#app");
